import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-link',
  templateUrl: './nav-link.component.html',
  styleUrls: ['./nav-link.component.scss']
})
export class NavLinkComponent {

  @Input() public label: string;
  @Input() public iconName: string;
  @Input() public link: string;

  constructor(private router: Router) {
    //
  }

  public isSelected() {
    return this.router.isActive(this.link, false);
  }

  public onClick() {
    this.router.navigateByUrl(this.link);
  }

}
